import { Typography } from "@mui/material";
import { forwardRef } from "react";
import { Row } from "v2/components/base/Flex/ui";

const ScrollableLoadMore = forwardRef((props, ref) => {
  return (
    <Row type="cc" height="50px" ref={ref} fullWidth>
      <Typography variant="mobile-body-s" color="text.secondary" sx={{ opacity: 0.5 }}>
        Loading more...
      </Typography>
    </Row>
  );
});

export default ScrollableLoadMore;
